import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

//updateMailDelivery
export const updateMaildelivery = createAsyncThunk('mailDeliverySlice/updateMaildelivery', async (value) => {
  try {
    const response = await axios.put('/GetADDetails/maildelivery', value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return error;
  }
});
//updateDomainMailDelivery
export const updateDomainMailDelivery = createAsyncThunk('DomainMailDelivery/domainMaildeliveryrule', async (value) => {
  try {
    const response = await axios.post('/DomainMailDelivery/domainmaildeliveryrule', value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { status: error.response.status, data: error.response.data };
  }
});
//TestMailforMicrosoftMail
export const testMicrosoftMail = createAsyncThunk('mailDeliverySlice/testMicrosoftMail', async (value) => {
  try {
    const response = await axios.post('/GetADDetails/office365testmail', value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return error;
  }
});
//TestMailforStandardEmail
export const testStandardEmail = createAsyncThunk('mailDeliverySlice/testStandardEmail', async (value) => {
  try {
    const response = await axios.post('/GetADDetails/Smtptestmail', value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return error;
  }
});
//TestMailforGmail
export const testGmail = createAsyncThunk('mailDeliverySlice/testGmail', async (value) => {
  try {
    const response = await axios.post('/GetADDetails/testgmail', value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return error;
  }
});
//TestMailforGmailforDomain
export const testDomainGmail = createAsyncThunk('mailDeliverySlice/testGmail', async (value) => {
  try {
    const response = await axios.post(`/GetADDetails/domaintestgmail`, value);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { status: error.response.status, data: error.response.data };
  }
});
//getGmailDelivery
export const getGmailDelivery = createAsyncThunk('mailDeliverySlice/getGmailDelivery', async () => {
  const response = await axios.get(`/GetADDetails/getgmail`);
  return response.data;
});
//getMicrosoftMailDelivery
export const getMicrosoftMailDelivery = createAsyncThunk('mailDeliverySlice/getMicrosoftMailDelivery', async () => {
  const response = await axios.get(`/GetADDetails/getmicrosoftemail`);
  return response.data;
});
//getEmailDelivery
export const getEmailDelivery = createAsyncThunk('mailDeliverySlice/getEmailDelivery', async () => {
  const response = await axios.get(`/GetADDetails/getemaildelivery`);
  return response.data;
});
//getEmailDeliverySettings
export const getEmailDeliverySettings = createAsyncThunk('mailDeliverySlice/getEmailDeliverySettings', async () => {
  const response = await axios.get(`/GetADDetails/getmailsettings`);
  return response.data;
});
//getDomainGmailDelivery
export const getDomainGmailDelivery = createAsyncThunk('mailDeliverySlice/getDomainGmailDelivery', async (value) => {
  const response = await axios.get(`/DomainMailDelivery/getdomaingmail?domainId=${value}`);
  return response.data;
});
//getDomainMicrosoftMailDelivery
export const getDomainMicrosoftMailDelivery = createAsyncThunk(
  'mailDeliverySlice/getDomainMicrosoftMailDelivery',
  async (value) => {
    const response = await axios.get(`/DomainMailDelivery/getdomainmicrosoftmail?domainId=${value}`);
    return response.data;
  }
);
//getDomainEmailDelivery
export const getDomainEmailDelivery = createAsyncThunk('mailDeliverySlice/getDomainEmailDelivery', async (value) => {
  const response = await axios.get(`/DomainMailDelivery/getsmptmail?domainId=${value}`);
  return response.data;
});
//getDomainEmailDeliverySettings
export const getDomainEmailDeliverySettings = createAsyncThunk(
  'mailDeliverySlice/getDomainEmailDeliverySettings',
  async (value) => {
    const response = await axios.get(`/DomainMailDelivery/getdomainmailsetting?domainId=${value}`);
    return response.data;
  }
);
//uploadGmailfile
export const uploadGmailFile = createAsyncThunk('mailDeliverySlice/uploadGmailFile', async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(`/GetADDetails/Upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return { status: response.status, data: response.data };
  } catch (err) {
    return err.message;
  }
});
//uploadDomainGmailfile
export const uploadDomainGmailFile = createAsyncThunk('mailDeliverySlice/uploadDomainGmailFile', async (formData) => {
  try {
    const response = await axios.post(`/GetADDetails/domainUpload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});
const initialState = {
  gmailDeliveryLoading: false,
  gmailDeliveryData: null,
  gmailDeliveryError: null,
  microsoftMailDeliveryLoading: false,
  microsoftMailDeliveryData: null,
  microsoftMailDeliveryError: null,
  emailDeliveryLoading: false,
  emailDeliveryData: null,
  emailDeliveryError: null,
  domainGmailDeliveryLoading: false,
  domainGmailDeliveryData: null,
  domainGmailDeliveryError: null,
  domainMicrosoftMailDeliveryLoading: false,
  domainMicrosoftMailDeliveryData: null,
  domainMicrosoftMailDeliveryError: null,
  domainEmailDeliveryLoading: false,
  domainEmailDeliveryData: null,
  domainEmailDeliveryError: null,
  getEmailDeliverySettingsLoading: false,
  getEmailDeliverySettingsData: null,
  getEmailDeliverySettingsError: null,
  getDomainEmailDeliverySettingsLoading: false,
  getDomainEmailDeliverySettingsData: null,
  getDomainEmailDeliverySettingsError: null,
};

const mailDeliverySlice = createSlice({
  name: 'mailDelivery',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGmailDelivery.pending, (state) => {
        state.gmailDeliveryLoading = true;
      })
      .addCase(getGmailDelivery.fulfilled, (state, action) => {
        state.gmailDeliveryLoading = false;
        state.gmailDeliveryData = action.payload;
        state.gmailDeliveryError = null;
      })
      .addCase(getGmailDelivery.rejected, (state, action) => {
        state.gmailDeliveryLoading = false;
        state.gmailDeliveryData = null;
        state.gmailDeliveryError = action.error.message;
      })
      .addCase(getDomainGmailDelivery.pending, (state) => {
        state.domainGmailDeliveryLoading = true;
      })
      .addCase(getDomainGmailDelivery.fulfilled, (state, action) => {
        state.domainGmailDeliveryLoading = false;
        state.domainGmailDeliveryData = action.payload;
        state.domainGmailDeliveryError = null;
      })
      .addCase(getDomainGmailDelivery.rejected, (state, action) => {
        state.domainGmailDeliveryLoading = false;
        state.domainGmailDeliveryData = null;
        state.domainGmailDeliveryError = action.error.message;
      })
      .addCase(getMicrosoftMailDelivery.pending, (state) => {
        state.microsoftMailDeliveryLoading = true;
      })
      .addCase(getMicrosoftMailDelivery.fulfilled, (state, action) => {
        state.microsoftMailDeliveryLoading = false;
        state.microsoftMailDeliveryData = action.payload;
        state.microsoftMailDeliveryError = null;
      })
      .addCase(getMicrosoftMailDelivery.rejected, (state, action) => {
        state.microsoftMailDeliveryLoading = false;
        state.microsoftMailDeliveryData = null;
        state.microsoftMailDeliveryError = action.error.message;
      })
      .addCase(getDomainMicrosoftMailDelivery.pending, (state) => {
        state.domainMicrosoftMailDeliveryLoading = true;
      })
      .addCase(getDomainMicrosoftMailDelivery.fulfilled, (state, action) => {
        state.domainMicrosoftMailDeliveryLoading = false;
        state.domainMicrosoftMailDeliveryData = action.payload;
        state.domainMicrosoftMailDeliveryError = null;
      })
      .addCase(getDomainMicrosoftMailDelivery.rejected, (state, action) => {
        state.domainMicrosoftMailDeliveryLoading = false;
        state.domainMicrosoftMailDeliveryData = null;
        state.domainMicrosoftMailDeliveryError = action.error.message;
      })
      .addCase(getEmailDelivery.pending, (state) => {
        state.emailDeliveryLoading = true;
      })
      .addCase(getEmailDelivery.fulfilled, (state, action) => {
        state.emailDeliveryLoading = false;
        state.emailDeliveryData = action.payload;
        state.emailDeliveryError = null;
      })
      .addCase(getEmailDelivery.rejected, (state, action) => {
        state.emailDeliveryLoading = false;
        state.emailDeliveryData = null;
        state.emailDeliveryError = action.error.message;
      })
      .addCase(getDomainEmailDelivery.pending, (state) => {
        state.domainEmailDeliveryLoading = true;
      })
      .addCase(getDomainEmailDelivery.fulfilled, (state, action) => {
        state.domainEmailDeliveryLoading = false;
        state.domainEmailDeliveryData = action.payload;
        state.domainEmailDeliveryError = null;
      })
      .addCase(getDomainEmailDelivery.rejected, (state, action) => {
        state.domainEmailDeliveryLoading = false;
        state.domainEmailDeliveryData = null;
        state.domainEmailDeliveryError = action.error.message;
      })
      .addCase(getEmailDeliverySettings.pending, (state) => {
        state.getEmailDeliverySettingsLoading = true;
      })
      .addCase(getEmailDeliverySettings.fulfilled, (state, action) => {
        state.getEmailDeliverySettingsLoading = false;
        state.getEmailDeliverySettingsData = action.payload;
        state.getEmailDeliverySettingsError = null;
      })
      .addCase(getEmailDeliverySettings.rejected, (state, action) => {
        state.getEmailDeliverySettingsLoading = false;
        state.getEmailDeliverySettingsData = null;
        state.getEmailDeliverySettingsError = action.error.message;
      })
      .addCase(getDomainEmailDeliverySettings.pending, (state) => {
        state.getDomainEmailDeliverySettingsLoading = true;
      })
      .addCase(getDomainEmailDeliverySettings.fulfilled, (state, action) => {
        state.getDomainEmailDeliverySettingsLoading = false;
        state.getDomainEmailDeliverySettingsData = action.payload;
        state.getDomainEmailDeliverySettingsError = null;
      })
      .addCase(getDomainEmailDeliverySettings.rejected, (state, action) => {
        state.getDomainEmailDeliverySettingsLoading = false;
        state.getDomainEmailDeliverySettingsData = null;
        state.getDomainEmailDeliverySettingsError = action.payload;
      });
  },
});
export default mailDeliverySlice.reducer;
